export default {
  reports: {
    header: {
      title: 'Actividad en búsquedas',
    },
    body: {
      filters: {
        placeholders: {
          search: 'Buscar por descripción del ítem o nombre de la empresa compradora',
          category: 'Ingrese categoría',
          buyer: 'Ingrese empresa compradora',
          search_type: 'Ingrese el tipo de busqueda',
          date_range: 'Seleccione un intervalo de máximo 3 meses.',
        },
      },
      actions: {
        search: 'Buscar',
        excel: 'Generar Excel',
      },
      graph: {
        title: {
          part_1: 'Sus productos han aparecido',
          part_2: 'veces',
          part_3: 'entre',
        },
      },
      table: {
        columns: {
          date: 'Fecha',
          user: 'Usuario',
          buyer: 'Empresa Compradora',
          keyword: 'Palabra buscada',
          item: 'Ítem',
          sku: 'Sku',
          price: 'Precio',
          code: 'Código',
          category: 'Categoría',
          search_type: 'Tipo de búsqueda',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/reports.js